import { useLocation } from 'react-router-dom'

import QueryString from 'query-string'

import { EarlyQueryStringParams } from '../types'

export function useGetEarlyFlow() {
  const location = useLocation()
  const queryString = QueryString.parse(location.search)
  const isInitialOnboardingFlow =
    queryString?.flow === EarlyQueryStringParams.initalOnboarding ?? false
  const isResumeOnboardingFlow =
    queryString?.flow === EarlyQueryStringParams.resumeOnboarding ?? false
  const flow = queryString?.flow || EarlyQueryStringParams.moneyMovement

  return {
    isInitialOnboardingFlow,
    isResumeOnboardingFlow,
    flow,
  }
}
